import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { SET_TRU_VALIDATE_BLACKBOX } from '../../Auth/AuthReducer'
import './TruValidate.scss'

const TruValidate = (props) => {
  const dispatch = useDispatch()
  const { TruValidateIsEnabled = false } = useSelector(
    (state) => state.app.appSettings,
    shallowEqual
  )
  const [localBlackbox, setLocalBlackbox] = useState({})
  const { children } = props

  const populateBlackBox = async () => {    
    if (window.IGLOO && window.IGLOO.getBlackbox) {
      const data = await window.IGLOO.getBlackbox()
      dispatch({ type: SET_TRU_VALIDATE_BLACKBOX, blackbox: data })
      setLocalBlackbox(data)
    }
  }

  useEffect(() => {
    if (TruValidateIsEnabled && (!localBlackbox || Object.keys(localBlackbox).length === 0))
      populateBlackBox()
  }, [localBlackbox, TruValidateIsEnabled, window.IGLOO])

  return <React.Fragment>{children}</React.Fragment>
}

export const buildTruValidateInfo = (truValidateRequest) => ({
  BlackBox: truValidateRequest ? truValidateRequest.BlackBox : null,
})

export default TruValidate



// WEBPACK FOOTER //
// ./src/components/TruValidate/TruValidate.js